export default __webpack_public_path__ + "static/media/hht1_ep11_book_wp_02.360935b3.jpg";